<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_list>Реестр отправлений</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Редактировать письмо</li>
        </ol>
    </nav>

	<div v-if="deliveryWay === 3 || deliveryWay === 4" class="toggle-container">
        <label style="padding: 0px;" class="form-label">Отправка рассылки</label>
        <label class="switch">
            <input v-model="activeMailing" type="checkbox">
            <span class="slider"></span>
        </label>
    </div>

    <div class="letter-add_input">
        <div v-if="deliveryWay === 1 || deliveryWay === 2" class="mb-4">
            <div class="form-label">Шаблон письма</div>
            <v-select class="select"
                v-model="emailTemplate"
                :items="emailTemplates"
                @update:modelValue="onChangeTemplate"
                @update:menu="$removeFocus"
                @click:clear="$removeFocus"
                @click:control="$removeFocus"
                item-title="name"
                item-value="id"
                variant="outlined"
                color="primary"
                density="compact"
                clearable>
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>
        </div>

        <div class="mb-4 input-field">
            <label class="form-label">Название письма</label>
            <input v-model="emailName"
                   :disabled="deliveryWay === 3 || deliveryWay === 4"
                   type="text"
                   class="form-control"
                   placeholder="">
        </div>

        <div class="mb-4 input-field">
            <label class="form-label">Тема письма</label>
            <input v-model="emailSubject"
                   :disabled="deliveryWay === 3 || deliveryWay === 4"
                   type="text"
                   class="form-control"
                   placeholder="">
        </div>

        <div class="v-select-input">
            <div class="mb-4">
                <div class="form-label">Отправитель</div>
                <v-select class="select"
                    :disabled="deliveryWay === 3 || deliveryWay === 4"
                    v-model="sender"
                    :items="senders"
                    @update:modelValue="onChangeSender"
                    @update:menu="$removeFocus"
                    @click:clear="$removeFocus"
                    @click:control="$removeFocus"
                    item-title="name"
                    item-value="id"
                    variant="outlined"
                    color="primary"
                    density="compact"
                    clearable>
                    <template #no-data>
                        <v-list-item>
                            <span>Данные не найдены</span>
                        </v-list-item>
                    </template>
                </v-select>
            </div>
        </div>

        <div class="recievers">
            <div class="recievers__group">
                <div class="text-input-group">
                    <div style="position: relative;" class="mb-4 input-field">
                        <label class="form-label">Email адреса получателей</label>
                        <input ref="emailInput"
                               v-model="receiversEmails"
                               @keypress.enter="validateEmails"
                               type="text"
                               :class="emailError ? 'form-control input-error' : 'form-control'"
                               placeholder="Разделить через пробел"
                        >
                        <p class="text-error" v-if="emailError">{{ emailError }}</p>
                    </div>

                    <svg @click="validateEmails" class="email-add-btn" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 12L11 14L15 10M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C10.8181 3 9.64778 3.23279 8.55585 3.68508C7.46392 4.13738 6.47177 4.80031 5.63604 5.63604C4.80031 6.47177 4.13738 7.46392 3.68508 8.55585C3.23279 9.64778 3 10.8181 3 12Z" stroke="#0678F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>

                <div v-if="emails.length" class="letter-recievers-groups__selected-recievers mb-4">
                    <div class="selected-reciever"
                        v-for="(item, index) in emails">
                        {{ item }}
                        <svg @click="removeEmail(index, item.id)" class="selected-reciever__button" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_641_26163)">
                                <path d="M12 4L4 12" stroke="#242731" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M4 4L12 12" stroke="#242731" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_641_26163">
                                    <rect width="16" height="16" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
            </div>

            <div class="or-label">и/или</div>

            <div class="recievers__group">
                <div class="mb-4">
                    <div class="form-label">Группа получателей</div>
                    <v-select
                        class="select"
                        v-model="receiversGroupIds"
                        :items="receiversGroups"
                        item-title="name"
                        item-value="id"
                        variant="outlined"
                        color="primary"
                        density="compact"
                        multiple
                        clearable
                        @update:menu="$removeFocus"
                        @click:clear="$removeFocus"
                        @click:control="$removeFocus">
                        <template #no-data>
                            <v-list-item>
                                <span>Данные не найдены</span>
                            </v-list-item>
                        </template>
                        <template #selection="{ item, index }">
                            <v-chip v-if="index < 3" :text="item.title"></v-chip>
                            <span v-if="index === 3" class="text-grey text-caption align-self-center">
                                    + еще {{ receiversGroupIds.length - 3 }}
                                </span>
                        </template>
                    </v-select>
                </div>
            </div>
        </div>

        <div class="mailing__delivery-way">
            <div class="mb-4">
                <div class="input-label">Способ отправки</div>
                <v-select class="select"
                    v-model="deliveryWay"
                    :items="deliveryWays"
                    @update:modelValue="onChangeDeliveryWay"
                    @update:menu="$removeFocus"
                    @click:clear="$removeFocus"
                    @click:control="$removeFocus"
                    item-title="name"
                    item-value="id"
                    variant="outlined"
                    color="primary"
                    density="compact"
                    clearable>
                    <template #no-data>
                        <v-list-item>
                            <span>Данные не найдены</span>
                        </v-list-item>
                    </template>
                </v-select>
            </div>

            <div v-if="deliveryWayId === schedule_sending_type" class="mb-4">
                <div class="input-label">Выберите дату и время</div>
                <div class="schedule mb-4">
                    <input v-model="datePlaned" :min="dateToday" class="form-control input-field__date" type="date">

                    <div class="me-3 input-field__date">
                        <input v-model="timePlaned" class="form-control" id="scheduleTime" type="time">
                    </div>
                </div>
            </div>

            <div v-if="deliveryWayId === weekly_sending_type" class="mb-4">
                <div class="input-label">Выберите день недели и время</div>
                <div class="schedule mb-4">
                    <v-select class="select"
                        v-model="weekDay"
                        :items="weekDays"
                        @update:modelValue="onChangeWeekDay"
                        @update:menu="$removeFocus"
                        @click:clear="$removeFocus"
                        @click:control="$removeFocus"
                        item-title="name"
                        item-value="id"
                        variant="outlined"
                        color="primary"
                        density="compact"
                        clearable>
                        <template #no-data>
                            <v-list-item>
                                <span>Данные не найдены</span>
                            </v-list-item>
                        </template>
                    </v-select>

                    <div class="me-3 input-field__date">
                        <input v-model="timePlaned" class="form-control" id="scheduleTime" type="time">
                    </div>
                </div>
            </div>

            <div v-if="deliveryWayId === once_every_few_days_sending_type" class="mb-4">
                <div class="input-label">День недели</div>
                <div class="week-days">
                    <div v-for="day in weekDays" :key="day.id" class="form-check">
                        <input
                            :id="`day${day.id}`"
                            class="form-check-input"
                            type="checkbox"
                            :checked="this.selectedWeekDays.includes(day.id)"
                            @click="selectWeekDay(this.selectedWeekDays, day)"
                        >
                        <label :for="`day${day.id}`" class="form-check__label">{{ day.name }}</label>
                    </div>
                </div>
                <div class="mb-4 input-field__date">
                    <label class="input-label">Время отправки</label>
                    <input v-model="timePlaned" class="form-control" id="scheduleTime" type="time">
                </div>
                <div class="mb-4">
                    <div class="schedule mb-4">
                        <div>
                            <label class="input-label">Дата начала рассылки</label>
                            <input v-model="mailing_date_start" @change="setDate($event)" :min="dateToday" class="form-control input-field__date" type="date">
                        </div>
                        <div>
                            <label class="input-label">Дата окончания рассылки</label>
                            <input v-model="mailing_date_end" :min="dateToday" id="mailing-date-end" class="form-control input-field__date" type="date">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="leter-add-controls" class="letter_construct" style="display:block">
        <TinyMCE
            :key="editorIndex"
            :init="editorConfig"
            v-model="content"
        />

        <div class="letter-add-controls__control-buttons">
            <div class="left-side">
                <ConfirmBtn class="btn btn-lg btn-primary me-3" 
                    :text="'Сохранить и выйти'"
                    @btnClick="save"
                />
                <a :href="route_list" id="cancelButton" class="btn btn-lg btn-outline-dark me-3">Отменить</a>
            </div>
        </div>
    </div>

    <Alert />

    <Transition name="fade">
        <NoRecieversModal v-if="showModal" @closeModal="closeModal" @save="save"/>
    </Transition>
</template>

<script>
import '/tinymce/tinymce.min.js';
import '/tinymce/icons/default/icons.min.js';
import '/tinymce/themes/silver/theme.min.js';
import '/tinymce/models/dom/model.min.js';
import TinyMCE from '@tinymce/tinymce-vue';
import axios from 'axios';
import Mailings from '../../../../models/Mailings/Mailings';
import NoRecieversModal from '../../../../modals/NoRecieversModal.vue';
import Alert from '../../../alerts/Alert.vue';
import {mapMutations} from 'vuex/dist/vuex.cjs.js';
import {value} from "lodash/seq";
import ConfirmBtn from '../../../../elements/ConfirmBtn.vue';

export default {
    name: 'MailingEditComponent',
    props: {
        route_list: String,
        route_sender_list: String,
        route_create: String,
        route_templates_list: String,
        route_receivers_group_list: String,
        route_sending_types_list: String,
        route_weekdays_list: String,
        route_edit_mailing: String,
        route_get: String,
        schedule_sending_type: Number,
        weekly_sending_type: Number,
        once_every_few_days_sending_type: Number,
        tinymce_keys: [Object],
        actived_status: Number,
        scheduled_status: Number,
        mailing_id: [String, Number]
    },
    components: {
        Alert,
        NoRecieversModal,
        TinyMCE,
        ConfirmBtn
    },
    data: function () {
        return {
            mailing: new Mailings({
                route_get: this.route_get
            }),
            document_base_url: '',
            content: '',
            emailName: '',
            emailSubject: '',

            status: '',

            sender_id: '',
            sender: '',
            senders: [],

            emailTemplateId: '',
            emailTemplate: '',
            emailTemplates: [],

            receiversGroupIds: [],
            receiversGroups: [],
            receiversEmails: '',

            deliveryWayId: '',
            deliveryWay: '',
            deliveryWays: [],

            weekDayId: [],
            weekDay: '',
            weekDays: [],
            checkedWeekDays: [],
            selectedWeekDays: [],

            datePlaned: '',
            timePlaned: '',

            activeMailing: '',

            mailing_date_start: '',
            mailing_date_end: '',

            deliveryWayDescription: '',

            dateToday: '',

            tinymceKeys: [
                this.tinymce_keys.primary,
                this.tinymce_keys.spare
            ],
            editorIndex: 0,
            keyIndex: null,
            editorInstance: null,

            emails: [],
            emailError: '',

            limit: 9999,

            showModal: false
        };
    },

    computed: {
        weekDaysLoaded() {
            if (this.weekDay !== '' && this.weekDays.length) {
                return true;
            } else {
                return false;
            }
        },
        editorConfig() {
            return {
                language: 'ru',
                base_url: '/tinymce',
                suffix: '.min',
                plugins: [
                    'image', 'autoresize', 'code', 'media', 'autolink',
                    'table', 'lists', 'preview', 'link'
                ],
                toolbar1:
                    'newdocument | insertfile undo redo | bold italic underline strikethrough | ' +
                    'alignleft aligncenter alignright alignjustify | cut copy paste | numlist bullist | ' +
                    'tabulation outdent indent | image media | code | table styleselect formatselect fontselect fontsizeselect | ' +
                    'removeformat | preview',
                toolbar_mode: 'wrap',
                toolbar_sticky: false,
                min_height: 400,
                image_advtab: true,
                file_picker_types: 'file image media',
                default_link_target: '_blank',
                link_context_toolbar: true,
                relative_urls: false,
                remove_script_host: false,
                link_title: false,
                document_base_url: this.document_base_url,
                paste_as_text: false,
                paste_data_images: true,
                paste_merge_formats: false,
                valid_elements: '*[*]',
                paste_webkit_styles: 'all',
                content_style: 'body { max-width: 600px; margin: 0 auto; }',
                setup: (editor) => {
                    this.editorInstance = editor;

                    editor.on('init', () => {
                        this.getMailing();
                    });

                    editor.ui.registry.addButton('tabulation', {
                        icon: 'chevron-right',
                        tooltip: 'Отступ строки',
                        onAction: () => {
                            editor.execCommand('mceInsertContent', false, '&nbsp;&nbsp;&nbsp;&nbsp;');
                        }
                    });
                },
                images_upload_handler: this.uploadFunction,
            };
        }
    },

    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        async save() {
            await this.validateEmails();

            if (this.emailName === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Введите название письма' });
                this.toggleLoading();
                return;
            }

            if (this.emailSubject === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Укажите тему письма' });
                this.toggleLoading();
                return;
            }

            if (this.sender_id == null) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Укажите отправителя' });
                this.toggleLoading();
                return;
            }

            if (this.emailError) {
                this.toggleLoading();
                return;
            }

            if (this.deliveryWayId === this.schedule_sending_type || this.deliveryWayId === this.weekly_sending_type) {
                if (this.timePlaned == '') {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Укажите время отправки' });
                    this.toggleLoading();
                    return;
                }
            }

            if (this.receiversEmails.length > 0) await this.validateEmails();

            if (this.emailError.length > 0) {
                this.$refs.emailInput.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
                return;
            }

            if (this.emailName === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Введите название письма' });
                this.toggleLoading();
                return;
            }

            if (this.emailSubject === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Укажите тему письма' });
                this.toggleLoading();
                return;
            }

            if (this.sender_id == null) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Укажите отправителя' });
                this.toggleLoading();
                return;
            }

            if (this.emailError) return;

            if (!this.emails.length && !this.receiversEmails && !this.receiversGroupIds.length) {
                localStorage.setItem('noRecievers', true);
            }

            let updateMailing = await axios.post(this.route_edit_mailing,
                {
                    name: this.emailName,
                    type: this.deliveryWayId,
                    sender_id: this.sender_id,
                    letter_subject: this.emailSubject,
                    letter_group_id: this.receiversGroupIds,
                    letter_template_id: this.template_id,
                    emails: this.emails.length ? this.emails.join(' ') : ' ',
                    day_week: this.weekDayId,
                    date_planed: this.datePlaned,
                    time_planed: this.timePlaned,
                    start: this.mailing_date_start,
                    end: this.mailing_date_end,
                    active_mailing: this.activeMailing,
                    id: this.mailing_id,
                    letter_body: `<div style="max-width: 600px; margin: 0 auto"${this.editorInstance.getContent()}</div>`,
                }
            );

            if (updateMailing.data.status == 'ok') {
                window.location.href = this.route_list;
            } else {
                this.addAlert({ type: 'error', title: 'Ошибка', text: updateMailing.data.message });
                this.toggleLoading();
            }
        },
        getMailing: async function () {
            let item = await this.mailing.get(this.mailing_id);
            this.emailName = item.name;
            this.emailSubject = item.letter_subject;
            this.emailTemplateId = item.letter_template_id;
            this.body = item.letter_body;
            this.sender_id = item.sender_id;
            this.receiversGroupIds = item.letter_group_id ?? [];
            this.emails = item.emails ? item.emails.split(' ') : [];
            this.deliveryWayId = item.type;
            this.deliveryWay = item.type;
            this.datePlaned = this.dateFormat(item.date_planed);
            this.timePlaned = item.time_planed;
            this.status = item.status;
            this.mailing_date_start = item.start;
            this.mailing_date_end = item.end;
            this.weekDay = item.day_week;
            this.selectedWeekDays = item.day_week;

            if (this.selectedWeekDays != null) {
                this.checkedWeekDays = this.selectedWeekDays;
                this.weekDayId = this.checkedWeekDays;
            }

            this.activeMailing = (this.status === this.actived_status) || (this.status === this.scheduled_status);

            this.editorInstance.setContent(this.body)
        },
        getWeekDaysList: async function () {
            let data = await axios.get(this.route_weekdays_list);
            this.weekDays = data.data;
        },
        getMailingsSendingTypesList: async function () {
            let data = await axios.get(this.route_sending_types_list);
            this.deliveryWays = data.data;
        },
        getReceiversGroups: async function () {
            let data = await axios.get(
                this.route_receivers_group_list,
                {
                    params: {
                        limit: 1000,
                    }
                }
            );
            this.receiversGroups = data.data.items;
        },
        getTemplates: async function () {
            let data = await axios.get(
                this.route_templates_list,
                {
                    params: {
                        limit: 1000,
                    }
                }
            );
            this.emailTemplates = data.data.items;
        },
        getSenders: async function () {
            let senders = await axios.get(
                this.route_sender_list,
                {
                    params: {
                        limit: 1000,
                    }
                }
            );
            this.senders = senders.data.items;
        },
		onChangeSender: async function (id) {
            if (id) {
                const sender = this.senders.find(item => item.id === id);
                this.sender_id = sender.id;
                this.header = sender.header;
                this.footer = sender.footer;
                this.addHeaderAndFooter();
            } else {
                this.sender_id = null;
            }
        },
		onChangeTemplate: async function (id) {
            const template = this.emailTemplates.find(item => item.id === id);
            this.template_id = template.id;
            this.emailName = template.name;
            this.emailSubject = template.subject;
            this.sender = this.senders.find(obj => obj.id === this.sender_id).name;
            this.sender_id = template.sender_id;
            this.template = template.body;
            this.addTemplate();
        },
        onChangeDeliveryWay: async function (id) {
            this.datePlaned = '';
            this.timePlaned = '';
            this.weekDay = '';
            this.weekDayId = '';
            this.mailing_date_start = '';
            this.mailing_date_end = '';
            this.checkedWeekDays = [];
            this.selectedWeekDays = '';
            this.deliveryWayId = id;
            this.dateToday = new Date().toISOString().slice(0, 10);
        },
        onChangeWeekDay: async function (id) {
            this.weekDayId = [id];
        },
		addHeaderAndFooter: function () {
            if (this.editorInstance.getContent().includes('<div id="header">') && this.editorInstance.getContent().includes('<div id="footer">')) {
                let header = '<div id="header">';
                let letterText = '<div id="letterText">'
                let footer = '<div id="footer">';
                function escapeRegExp(string) {
                    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                }

                let regexHeader = new RegExp(`${escapeRegExp(header)}(.*?)${escapeRegExp(letterText)}`, 's');
                let regexFooter = new RegExp(`${escapeRegExp(footer)}(.*)`, 's');
                let newStr = this.editorInstance.getContent()
                this.editorInstance.setContent(newStr.replace(regexHeader, `${header}${this.header}${escapeRegExp('</div><div id="letterText">')}`))

                newStr = this.editorInstance.getContent()

                this.editorInstance.setContent(newStr.replace(regexFooter, `${footer}${this.footer}`))
            }
        },
		addTemplate: function () {
            this.editorInstance.setContent(this.template)
        },
        uploadFunction:  function(blobInfo, success, failure) {
            return new Promise((resolve, reject) => {
                const FormRequest = new FormData();
                FormRequest.append('image', blobInfo.blob());
                let imgUrl = null;
                axios.post('/technical/letter-constructor/upload', FormRequest).then((res) => {
                    if(res.data.status == 'ok') {
                        imgUrl = res.data.url;
                        resolve(imgUrl);
                    }
                });
            })
        },
        showWarning() {
            this.$refs.Warning.showWarning();
        },
        showError() {
            this.$refs.Error.showError();
        },
        selectWeekDay: function (selected_days, day) {
            let index = this.checkedWeekDays.indexOf(day.id);

            if (index !== -1) {
                this.checkedWeekDays.splice(index, 1)
            } else {
                this.checkedWeekDays.push(day.id)
            }

            this.weekDayId = this.checkedWeekDays;
        },
        dateFormat: (date, displayTime = false) => {
            if (typeof date === 'string') {
                return date.replace(/(\d{4})-(\d{2})-(\d{2})(?:\s|T)([\d\:]+).*/, '$1-$2-$3' + (displayTime ? ' $4' : ''))
            }
            return ''
        },
        setDate: async function(e) {
            const selectedDateFrom = new Date(e.target.value);
            selectedDateFrom.setDate(selectedDateFrom.getDate() + 1);
            const $date = selectedDateFrom.toISOString().slice(0, 10);
            document.getElementById('mailing-date-end').setAttribute('min', $date);
            document.getElementById('mailing-date-end').value = '';
        },
        async validateEmails() {
            if (!this.receiversEmails) return;
            const emailPattern = /^(?!.*\.\.)[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;
            const emails = this.receiversEmails.trim().split(/\s+/);
            let invalidEmails = [];

            emails.forEach(email => {
                if (emailPattern.test(email) && !this.emails.includes(email)) {
                    this.emails.push(email);
                } else {
                    invalidEmails.push(email);
                    this.emailError = 'Проверьте, что адреса соответствуют формату (a@a.ru), разделены пробелом, не содержат кириллицы и запрещённых символов ( , : ! и т.п), а также не повторяются.';
                    this.$refs.emailInput.scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                    });
                }
            });
            this.receiversEmails = invalidEmails.join(' ');
            if (!this.receiversEmails) this.emailError = '';
        },
        removeEmail: async function (index) {
            this.emails.splice(index, 1);
        },
        setSender() {
            if (this.senders.length > 0 && this.sender_id !== '') {
                this.sender = this.senders.find(obj => obj.id === this.sender_id).name;
            }
        },
        setEmailTemplateId() {
            if (this.emailTemplates && this.emailTemplateId) {
                this.emailTemplate = this.emailTemplates[this.emailTemplates.findIndex(element => element.id === this.emailTemplateId)].name;
            }
        },
        closeModal() {
            this.showModal = false;
        }
    },
    mounted () {
        this.getSenders();
        this.getReceiversGroups();
        this.getTemplates();
        this.getMailingsSendingTypesList();
        this.getWeekDaysList();
    },
    watch: {
        senders(newValue) {
            if (newValue) {
                if (this.senders.length > 0 && this.sender_id !== '') {
                    this.setSender();
                }
            }
        },
        sender_id(newValue) {
            if (newValue) {
                if (this.senders.length > 0 && this.sender_id !== '') {
                    this.setSender();
                }
            }
        },
        emailTemplateId(newValue) {
            if (newValue) {
                if (this.emailTemplates.length > 0 && this.emailTemplateId != '') {
                    this.setEmailTemplateId();
                }
            }
        },
        receiversEmails: {
            handler(newValue) {
                if (newValue === '') this.emailError = '';
            }
        },
        weekDaysLoaded: {
            handler(newValue) {
                if (newValue === true) {
                    this.weekDay = this.weekDays.find(el => el.id === Number(this.weekDay));
                }
            }
        }
    },
}
</script>

<style scoped lang="scss">

.page-label {
    font-size: 18px;
    font-weight: 600;
}
.or-label {
    font-weight: 500;
    padding-top: 24px;
}
.input-label {
    font-size: 14px;
    font-weight: 600;
}
.text-input-group {
    display: flex;
    flex-direction: row;
    gap: 60px;
}
.input-field {
    width: 400px;
    &__date {
        width: 300px;
    }
}
.schedule {
    display: flex;
    flex-direction: row;
    gap: 24px;
}
.v-select-input {
    display: flex;
    flex-direction: row;
    gap: 30px;
}
.v-select {
    width: 400px;
}
.letter_construct .pattern_container {
    display: block;
    position: absolute;
    top: 30px;
    left: 260px;
    background-color: #fff;
    border: 1px solid #D1D1D1;
    border-radius: 5px;
}

.letter_construct .pattern_inner {
    line-height: 38px;
    padding: 0 24px;
    cursor: pointer;
    border-bottom: 1px solid #ddd;
}

.letter_construct .pattern_inner:hover {
    background-color: #1aa2fd;
    color: #fff;
}

.letter_construct .editor_container {
    position: relative;
}

.letter-add-controls {
    &__letter-buttons {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 0px 0px 20px 0px;
    }
    &__control-buttons {
        display: flex;
        flex-direction: row;
        margin: 20px 0px 20px 0px;
        gap: 18px;
        justify-content: space-between;
    }
}

.blue {
    color: #0678F4;
    font-size: 14px;
}

.black {
    color: black;
    font-size: 14px;
}

.left-side {
    display: flex;
    flex-direction: row;
    flex: 3;
}

.right-side {
    display: flex;
    flex-direction: row;
    flex: 2;
    justify-content: flex-end
}

#saveButton {
    padding: 0px 72px;
}

#previewButton {
    padding: 0px 30px;
}

#HTMLButton {
    padding: 0px 30px;
}

#cancelButton {
    padding: 0px 42px;
}

.mailing {
    &__recievers {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        gap: 60px;
    }
    &__selected-recievers {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 12px;
    }
    &__control-buttons {
        display: flex;
        flex-direction: row;
        gap: 4px;
    }
}

.selected-reciever {
    border: 1px solid #EAEEF4;
    border-radius: 5px;
    padding: 5px 8px;
    &__button {
        cursor: pointer;
    }
    &__button:hover {
        path {
            stroke: red;
            transition: stroke 0.15s ease;
        }
    }
}

.week-days {
    margin: 0px 0px 20px 0px;
    display: flex;
    flex-direction: row;
    gap: 12px;
}

.form-check__label {
    vertical-align: sub;
    cursor: pointer;
}

.vs--disabled > :first-child {
    background-color: #D1D1D1;
    cursor: not-allowed;
}

.text-error {
    font-size: 12px;
    font-weight: 400;
    color: #E33535;
}

.input-error {
    border: 1px solid #E33535;
}

.letter-recievers-groups {
    &__recievers {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        gap: 60px;
    }
    &__selected-recievers {
        display: flex;
        max-height: 130px;
        overflow-y: auto;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 12px;
    }
    &__control-buttons {
        display: flex;
        flex-direction: row;
        gap: 4px;
    }
}

.email-add-btn {
    align-self: center;
    margin-left: -46px;
    cursor: pointer;
}

.recievers {
    display: flex;
    gap: 46px;
    &__group {
        display: flex;
        flex-direction: column;
        max-width: 450px;
    }
}
</style>
